<template>
  <div>
    <el-card>
      <el-row class="flex-items" style="flex-wrap: wrap">
        <div class="flex-items mg-left">
          <div class="tui-rowTitle">学届：</div>
          <el-select
            v-model="levelValue"
            placeholder="请选择"
            @visible-change="getAcademicSelect"
            @change="onSelectLevel"
          >
            <el-option
              v-for="item in levelList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flex-items mg-left">
          <div class="tui-rowTitle">年级：</div>
          <el-select
            :popper-append-to-body="true"
            v-model="gradeValue"
            placeholder="请选择"
            @change="onSelectGrade"
          >
            <el-option
              v-for="item in gradeList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flex-items mg-left">
          <div class="tui-rowTitle">班级：</div>
          <el-select
            v-model="classValue"
            placeholder="请选择"
            @change="onClassSelect"
          >
            <el-option
              v-for="item in classList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flex-items mg-left">
          <div class="tui-rowTitle">文章类型：</div>
          <el-select
            v-model="typeListName"
            placeholder="请选择"
            style="width: 2.0625rem"
          >
            <el-option
              v-for="item in typeList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Name"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flex-items mg-left">
          <div class="tui-rowTitle">阅读状态：</div>
          <el-select
            v-model="statusListName"
            placeholder="请选择"
            style="width: 2.0625rem"
          >
            <el-option
              v-for="item in statusList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </div>
        <div class="flex-items mg-left">
          <div class="tui-rowTitle">文章名称：</div>
          <el-input
            v-model="Name"
            placeholder="请输入"
            style="width: 2.0625rem"
          ></el-input>
        </div>
        <div class="mg-left">
          <el-button type="goon" @click="GetReadArticleList">查询</el-button>
          <el-button type="goon" @click="onReset">清空</el-button>
        </div>
      </el-row>
    </el-card>

    <el-card style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="StudyYear" label="学届" align="center">
        </el-table-column>
        <el-table-column prop="ClassName" label="班级" align="center">
        </el-table-column>
        <el-table-column prop="CycleName" label="学期" align="center">
        </el-table-column>
        <el-table-column prop="StudentName" label="幼儿姓名" align="center">
        </el-table-column>
        <el-table-column prop="Type" label="文章类型" align="center">
        </el-table-column>
        <el-table-column prop="Title" label="文章名称" align="center">
        </el-table-column>
        <el-table-column prop="Status" label="阅读状态" align="center">
        </el-table-column>
        <el-table-column label="文章阅读时间" align="center">
          <template slot-scope="scope">
            {{ scope.row.ReadDatetime == "" ? "暂无" : scope.row.ReadDatetime }}
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
import {
  GetReadArticleList,
  GetClassSelect,
  getAcademicSelect,
  GetGradeList,
} from "../../api/api";

export default {
  data() {
    return {
      typeList: [
        {
          Id: "1",
          Name: "消毒防病",
        },
      ],
      statusList: [
        {
          Id: "1",
          Name: "已阅读",
        },
        {
          Id: "0",
          Name: "未阅读",
        },
      ],
      statusListName: null,
      typeListName: "",
      value1: "",
      tableData: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      levelList: [],
      gradeList: [],
      classList: [],
      studyYearId: 0,
      gradeId: 0,
      classId: 0,
      classValue: "",
      gradeValue: "",
      levelValue: "",
      userInfo: {},
      Name: "",
    };
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    this.GetReadArticleList();
  },
  methods: {
    //   学届下拉
    async getAcademicSelect() {
      let res = await getAcademicSelect({
        SchoolId: this.userInfo.SchoolId,
        Uid: this.userInfo.uID,
      });

      if (res.data.success) {
        this.levelList = res.data.response;
      }
    },
    // 年级下拉
    async GetGradeList() {
      ////console.log("年级下拉");
      let res = await GetGradeList({
        SchoolId: this.userInfo.SchoolId,
        studyYearId: this.studyYearId,
        Uid: this.userInfo.uID,
      });

      if (res.data.success) {
        this.gradeList = res.data.response;
        // this.gradeValue = res.data.response[this.gradedIndex].Name;
      }
    },
    // 学期下拉
    async GetClassSelect() {
      ////console.log("学期下拉");
      if (this.gradeList.length != 0 || this.levelList.length != 0) {
        let params = {
          SchoolId: this.userInfo.SchoolId,
          studyYearId: this.studyYearId,
          gradeId: this.gradeId,
        };
        let res = await GetClassSelect(params);
        if (res.data.success) {
          this.classList = res.data.response;
        } else {
        }
      }
    },
    async onSelectLevel(val) {
      this.PageIndex = 1;
      //   this.levelIndex = val;
      this.studyYearId = val;
      this.gradeValue = "";
      this.classValue = "";
      await this.GetGradeList();
      //   await this.GetClassSelect();
      // await this.GetReadArticleList();
    },
    async onSelectGrade(val) {
      this.PageIndex = 1;
      this.gradeId = val;
      await this.GetClassSelect();
      // await this.GetReadArticleList();
    },
    onClassSelect(val) {
      this.PageIndex = 1;
      this.classId = val;
      // this.GetReadArticleList();
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetReadArticleList();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.GetReadArticleList();
    },
    onReset() {
      this.statusListName = "";
      this.typeListName = "";
      this.gradeValue = "";
      this.classValue = "";
      this.levelValue = "";
      this.Name = "";
      this.GetReadArticleList();
    },
    async GetReadArticleList() {
      const params = {
        StudyYearId: this.studyYearId,
        ClassId: this.classId,
        Name: this.Name,
        SchoolId: this.userInfo.SchoolId,
        IsCheck: Number(this.statusListName),
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
      };
      let res = await GetReadArticleList(params);
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
.mg-left {
  margin-left: 0.25rem;
  margin-bottom: 0.25rem;
}
</style>